module.exports = __webpack_public_path__ + "img/ic-location-small.187f3855.svg";